<app-push-prompt
  [isOpen]="isPushPromptOpen"
  [source]="pushPromptSource"
  (accepted)="onPushPromptAccepted()"
  (dismissed)="onPushPromptDismissed()">
</app-push-prompt>

<div class="dynamic-clip" @fadeInOut>
    <div class="search-header" [class.visible]="isSearchHeaderVisible || isSearchActive">
        <input type="text" class="main-search" [placeholder]="'menu.search.placeholder' | translate"
            [(ngModel)]="searchQuery" (input)="onSearchInput($event)" (focus)="onSearchFocus()">
        <button class="close-search" *ngIf="isSearchActive" (click)="closeSearch()">
            {{ 'menu.search.cancel' | translate }}
        </button>
        <button type="button" class="language-chip"
            *ngIf="!isSearchActive && shouldShowSwitcher()"
            (click)="langSheet.open('switch')"
            [attr.aria-label]="'menu.language.switchTitle' | translate">
            <span class="language-chip__flag" *ngIf="activeLanguageFlag">{{ activeLanguageFlag }}</span>
            <span class="language-chip__code" *ngIf="!activeLanguageFlag">{{ currentLang | uppercase }}</span>
        </button>
    </div>
    <svg class="dc-hero" [class.hero-loading]="!heroImageLoaded" width="100%" viewBox="0 0 376 207" preserveAspectRatio="xMidYMid meet" fill="none"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M1.19214 145.264C0.276793 144.343 -0.22168 143.097 -0.22168 141.799V2.00002C-0.22168 -0.761408 2.01689 -2.99998 4.77832 -2.99998L371.445 -3C374.207 -3 376.445 -0.761431 376.445 1.99999V142.858C376.445 144.174 375.933 145.435 374.996 146.359C345.446 175.473 299.447 197.217 245.344 206.288C242.564 206.754 240 204.777 239.386 202.025C234.152 178.549 213.198 161 188.144 161C163.144 161 142.225 178.475 136.935 201.877C136.314 204.627 133.744 206.597 130.965 206.122C76.6113 196.839 30.5176 174.751 1.19214 145.264Z"
            fill="#D9D9D9" class="dc-hero-shade" />
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M1.19214 145.264C0.276793 144.343 -0.22168 143.097 -0.22168 141.799V2.00002C-0.22168 -0.761408 2.01689 -2.99998 4.77832 -2.99998L371.445 -3C374.207 -3 376.445 -0.761431 376.445 1.99999V142.858C376.445 144.174 375.933 145.435 374.996 146.359C345.446 175.473 299.447 197.217 245.344 206.288C242.564 206.754 240 204.777 239.386 202.025C234.152 178.549 213.198 161 188.144 161C163.144 161 142.225 178.475 136.935 201.877C136.314 204.627 133.744 206.597 130.965 206.122C76.6113 196.839 30.5176 174.751 1.19214 145.264Z"
            fill="url(#pattern0_19664_134)" class="dc-hero-img" />
        <defs>
            <pattern id="pattern0_19664_134" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image0_19664_134" transform="matrix(0.00132802 0 0 0.00238933 0 -0.121227)" />
            </pattern>
            <image id="image0_19664_134" width="753" height="470" preserveAspectRatio="none"
                [attr.xlink:href]="clientData.ios_header_url || '../../assets/default.jpg'" />
        </defs>
    </svg>
    <div class="circle-container">
        <div class="gradient-border" [routerLink]="['/events']">
            <!-- <div class="gradient-border"> -->
            <div class="image-circle">
                <img [src]="getCatalogueIconSrc()" alt="Profile image" (error)="onCatalogueIconError()">
            </div>
        </div>
        <h2>{{clientData.name}}</h2>
    </div>
</div>

<!-- Empty State for Inactive Subscription -->
<div class="subscription-empty-state" *ngIf="!hasActiveSubscription" @fadeInOut>
    <div class="empty-state-content">
        <h2>{{ 'menu.subscriptionInactive.title' | translate }}</h2>
        <p>{{ 'menu.subscriptionInactive.description' | translate }}</p>
        <img src="../../assets/no-results.png" alt="Subscription inactive" class="empty-state-image">
    </div>
</div>

<div class="search-container" [class.active]="isSearchActive" @slideInOut *ngIf="hasActiveSubscription">

    <!-- Full Screen Search Results -->
    <div class="search-results" *ngIf="isSearchActive">
        <!-- Empty State (themed icon + message, no baked asset) -->
        <div class="empty-search" *ngIf="!searchQuery">
            <svg class="search-glass" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2" />
                <line x1="16.5" y1="16.5" x2="21" y2="21" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" />
            </svg>
            <h3>{{ 'menu.search.prompt.title' | translate }}</h3>
            <p>{{ 'menu.search.prompt.subtitle' | translate }}</p>
        </div>

        <!-- Search Results -->
        <div class="search-results-content" *ngIf="searchQuery">
            <!-- No Results Message (themed icon + message, no baked asset) -->
            <div class="no-results" *ngIf="searchResults.length === 0">
                <svg class="search-glass" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true">
                    <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2" />
                    <line x1="16.5" y1="16.5" x2="21" y2="21" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" />
                </svg>
                <h3>{{ 'menu.search.noResults.title' | translate }}</h3>
                <p>{{ 'menu.search.noResults.subtitle' | translate }}</p>
                <button (click)="isSearchActive = false; searchQuery = ''">{{ 'menu.search.noResults.backButton' |
                    translate }}</button>
            </div>

            <!-- Results List -->
            <div class="search-items" *ngIf="searchResults.length > 0">
                <div class="menu-category">
                    <app-product-list-item
                        *ngFor="let product of searchResults"
                        [product]="product"
                        [currencySymbol]="currencySymbol"
                        [clientData]="clientData"
                        [cartQuantity]="getItemQuantity(product.id)"
                        [orderingEnabled]="canEnableOrdering()"
                        [cartSource]="'search'"
                        (productClicked)="onSearchResultClick($event)"
                        (sheetRequested)="onTileSheetRequested($event)"
                        (addToCartClicked)="addToCart($event, product)"
                        (quantityChanged)="updateQuantity($event.event, product, $event.change)"
                        (cartAdjusted)="onTileCartAdjusted($event)">
                    </app-product-list-item>
                </div>
            </div>

            <!-- Recent Searches -->
            <!-- <div class="search-section" *ngIf="recentSearches.size > 0">
                <h3>Recent Searches</h3>
                <div class="recent-searches">
                    <div *ngFor="let searchTerm of recentSearches" class="recent-search-item">
                        {{searchTerm}}
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>

<div #menuContainer @pageTransition *ngIf="hasActiveSubscription">
    <div class="sticky-nav" [class.visible]="isNavVisible && menuLayoutSlug !== 'browse'" @slideInOut>
        <div class="category-nav" @fadeInOut>
            <div *ngFor="let categoryGroup of categorizedProducts; trackBy: trackByCategory" class="nav-item"
                [class.active]="currentCategory === categoryGroup.category.id"
                (click)="scrollToCategory(categoryGroup.category.id!)" @bounceInOut>
                {{getTabLabel(categoryGroup)}}
            </div>
        </div>
    </div>
    <!-- Venue closed: ordering venue outside working hours (view-only menus never show this) -->
    <div class="venue-closed-card container" @fadeInOut *ngIf="!isSearchActive && isVenueClosedCardVisible()" role="status">
        <svg class="venue-closed-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
            <polyline points="12 7 12 12 15.5 14" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <div class="venue-closed-text">
            <h3>{{ 'menu.venueClosed.title' | translate }}</h3>
            <p>{{ 'menu.venueClosed.message' | translate }}</p>
        </div>
    </div>
    <div class="call-container container" @fadeInOut *ngIf="areCallActionsActive">
        <button (click)="callAction('waiter')" [disabled]="showWaiterSuccess || isActionLoading"
            [class.success]="showWaiterSuccess">
            <div *ngIf="!showWaiterSuccess">
                <img src="../../assets/CallBell.svg" alt="Call waiter"> {{ 'menu.actions.callWaiter.button' | translate
                }}
            </div>
            <div *ngIf="showWaiterSuccess">
                <img src="../../assets/success.svg" alt="Success"> {{ 'menu.actions.callWaiter.success' | translate }}
            </div>
        </button>

        <button (click)="showReceiptToast()" [disabled]="showReceiptSuccess || isActionLoading"
            [class.success]="showReceiptSuccess">
            <div *ngIf="!showReceiptSuccess">
                <img src="../../assets/Receipt.svg" alt="Call recepient"> {{ 'menu.actions.requestBill.button' |
                translate }}
            </div>
            <div *ngIf="showReceiptSuccess">
                <img src="../../assets/success.svg" alt="Success"> {{ 'menu.actions.requestBill.success' | translate }}
            </div>
        </button>
    </div>
    <div class="container" *ngIf="currentBanner" style="margin: 7% auto;" @fadeInOut>
        <div class="banner-media" [class.media-loading]="!bannerImageLoaded">
            <img [src]="currentBanner.imageUrl" [alt]="'Promotion banner'" (click)="handleBannerClick()"
                (load)="onBannerImageLoad()" (error)="onBannerImageError()"
                [style.visibility]="bannerImageLoaded ? 'visible' : 'hidden'"
                style="width: 100%; cursor: pointer;" @fadeInOut>
        </div>
    </div>
    <div *ngIf="featuredProducts.length > 0" class="most-ordered">
        <div class="most-ordered-header container">
            <h2>{{ 'menu.topProducts.title' | translate }}</h2>
            <!-- <a [routerLink]="['/most-ordered']">{{ 'menu.topProducts.viewAll' | translate }}</a> -->
        </div>
        <div class="most-ordered-items" [@listAnimation]="featuredProducts.length">
            <app-most-ordered-item *ngFor="let product of featuredProducts" [product]="product" [mainView]="true"
                [currencySymbol]="currencySymbol" [comesFrom]="comesFrom"></app-most-ordered-item>
        </div>
    </div>

    <!-- Browse layout: category grid -->
    <div *ngIf="!isSearchActive && menuLayoutSlug === 'browse'" class="menu-bottom-spacer" [style.--attr-bottom-space]="attractionsBottomSpaceCss">
        <app-category-grid
            [categories]="rawCategories"
            (categoryTapped)="onCategoryTapped($event)">
        </app-category-grid>
    </div>

    <!-- Default layout: vertical product list -->
    <div *ngIf="!isSearchActive && menuLayoutSlug !== 'browse'" class="menu-bottom-spacer" [style.--attr-bottom-space]="attractionsBottomSpaceCss">
        <div *ngFor="let categoryGroup of categorizedProducts; trackBy: trackByCategory" class="menu-category container"
            [attr.data-category-id]="categoryGroup.category.id" @fadeInOut>
            <h2>{{getCategoryDisplayName(categoryGroup.category, currentLang)}}</h2>

            <div [@listAnimation]="categoryGroup.products.length">
                <app-product-list-item
                    *ngFor="let product of categoryGroup.products; trackBy: trackByProduct"
                    [product]="product"
                    [currencySymbol]="currencySymbol"
                    [clientData]="clientData"
                    [cartQuantity]="getItemQuantity(product.id)"
                    [orderingEnabled]="canEnableOrdering()"
                    (productClicked)="onProductClick($event)"
                    (sheetRequested)="onTileSheetRequested($event)"
                    (addToCartClicked)="addToCart($event, product)"
                    (quantityChanged)="updateQuantity($event.event, product, $event.change)"
                    (cartAdjusted)="onTileCartAdjusted($event)"
                    @scaleInOut>
                </app-product-list-item>
            </div>
        </div>
    </div>
    <!-- Loading spinner -->
    <div *ngIf="loading" class="loading-spinner" @fadeInOut>
        <div class="spinner"></div>
    </div>
</div>


<!-- Waiter Toast -->
<div class="toast-container" *ngIf="showWaiterNotification" @slideInOut>
    <div class="toast">
        <h3>{{ 'menu.actions.callWaiter.toast.title' | translate }}</h3>
        <p>{{ 'menu.actions.callWaiter.toast.subtitle' | translate }}</p>
        <button (click)="showWaiterNotification = false">
            <img src="../../assets/x.svg" alt="close">
        </button>
        <img class="waiter-check" src="../../assets/waiter-check.svg" alt="waiter notified">
    </div>
</div>

<!-- Receipt Toast -->
<app-payment-method-sheet
    [open]="showReceiptNotification"
    [options]="billPaymentOptions"
    [busy]="isActionLoading"
    titleKey="menu.actions.requestBill.modal.title"
    subtitleKey="menu.actions.requestBill.modal.subtitle"
    (choose)="onBillPaymentChosen($event)"
    (dismiss)="showReceiptNotification = false">
</app-payment-method-sheet>

<!-- Full page loading overlay -->
<div class="loading-overlay" *ngIf="isActionLoading" @fadeInOut>
    <div class="loading-content">
        <div class="spinner"></div>
    </div>
</div>


<!-- Unavailable product alert -->
<div class="backdrop" *ngIf="showUnavailableAlert" @fadeInOut (click)="showUnavailableAlert = false"></div>
<div class="unavailable-alert" *ngIf="showUnavailableAlert" @slideInOut>
    <h3>{{ 'menu.availability.notAvailable' | translate }}</h3>
    <p>{{ unavailableAlertMessage }}</p>
    <button (click)="showUnavailableAlert = false">OK</button>
</div>

<!-- Tourist attractions (FE2-T168): draggable floating button + drop-to-open banner -->
<ng-container *ngIf="showsAttractions">
    <!-- Two banners, one slot. Flip ACTIVE_ATTRACTIONS_BANNER_STYLE to compare them on device;
         every other piece of this screen (scroll reveal, dismissal, the puck, cart stacking) keys
         off showAttractionsBanner and is indifferent to which one renders. -->
    <app-attractions-banner *ngIf="attractionsBannerStyle === 'classic'"
        [visible]="showAttractionsBanner"
        [city]="attractionsCity"
        [imageUrl]="attractionsLeadImage"
        [fromPrice]="clientData?.attractions_from_price ?? null"
        [currency]="clientData?.attractions_currency"
        [count]="clientData?.attractions_count || 0"
        [bottomInset]="attractionsBannerBottom"
        (bannerClick)="openAttractions()"
        (dismiss)="dismissAttractionsBanner()">
    </app-attractions-banner>

    <app-attractions-mosaic-banner *ngIf="attractionsBannerStyle === 'mosaic'"
        [visible]="showAttractionsBanner"
        [city]="attractionsCity"
        [imageUrls]="attractionsLeadImage ? [attractionsLeadImage] : []"
        [fromPrice]="clientData?.attractions_from_price ?? null"
        [currency]="clientData?.attractions_currency"
        [count]="clientData?.attractions_count || 0"
        [highlightTitle]="attractionsHighlightTitle"
        [moreCount]="attractionsMoreCount"
        (bannerClick)="openAttractions()"
        (dismiss)="dismissAttractionsBanner()">
    </app-attractions-mosaic-banner>

    <!-- Only after a dismissal: the puck is what the banner leaves behind, never a cold-start
         surface. Gated on the dismissal and NEVER on !showAttractionsBanner — that flips mid-drag,
         and destroying this component would kill the live pointer capture mid-gesture. -->
    <app-attractions-fab *ngIf="showAttractionsFab"
        [imageUrl]="attractionsLeadImage"
        [faded]="showAttractionsBanner"
        [enabled]="!attractionsBannerCommitted"
        (tap)="openAttractions('fab')"
        (dropInZone)="onAttractionsDropInZone()"
        (dragStateChanged)="onAttractionsDragStateChanged($event)">
    </app-attractions-fab>
</ng-container>

<app-floating-cart @slideInOut [bottomInset]="cartBottom" [clearsSafeArea]="cartClearsSafeArea"></app-floating-cart>
